import axios from "axios";
//import FormData from "form-data";
import {AdminBaseListEndPoint,} from "../../config/AppServerConfig";
import {GlobalConfig} from "./../../Services/Helper/GlobalConfig";

class AdminBaseListServices {
    static getAdminBaseList() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminBaseListEndPoint, config);
    }

}


export {AdminBaseListServices};
